import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography, Box } from "@mui/material";

function InProgress() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "25vh",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      {/* <CircularProgress size={50} sx={{ color: "#e55426" }} /> */}
      <Typography
        variant="h5"
        sx={{
          marginTop: "20px",
          color: "#333",
        }}
      >
        This feature is in progress. Please check back later.
      </Typography>
    </Box>
  );
}

export default InProgress;
